.page {
  max-width: 1120px;
  margin: 0 auto;
  padding: 64px 24px 80px;
  box-sizing: border-box;
}

.header {
  margin-bottom: 40px;
}

.title {
  margin: 0 0 8px;
  font-size: 32px;
  font-weight: 400;
  letter-spacing: 0.01em;
  text-align: center;
}

.subtitle {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  color: #505050;
  text-align: center;
}

@media (max-width: 768px) {
  .page {
    padding: 40px 16px 56px;
  }

  .title {
    font-size: 26px;
  }

  .subtitle {
    font-size: 15px;
  }
}
